/**
 * Where to send the user once the tutorial's import finishes, instead of My
 * Club. Session storage rather than router state because a first-timer logs
 * in on the tutorial, and a login can reload the page. The tutorial clears it
 * when it unmounts, so an abandoned visit never redirects a later one.
 */
const KEY = "CLUB_IMPORT_RETURN_TO";

export const setClubImportReturnTo = (path: string): void => {
  try {
    sessionStorage.setItem(KEY, path);
  } catch {}
};

export const getClubImportReturnTo = (): string | null => {
  try {
    return sessionStorage.getItem(KEY);
  } catch {
    return null;
  }
};

export const clearClubImportReturnTo = (): void => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // ignore: storage unavailable
  }
};
